import { Color, IconName } from '@billy/design-system'
import { ColorOrCurrent } from '@billy/design-system/src/types/colorOrCurrent'

import { TransactionStatus } from '@features/bankTransactions/types/transactionStatus'

interface StatusConfigItem {
  icon: IconName
  color: ColorOrCurrent
  backgroundColor?: Color
  translationKey: string
}

export const statusConfig: Record<TransactionStatus, StatusConfigItem> = {
  needsReview: {
    icon: 'circleDashed',
    color: 'currentColor',
    translationKey: 'bank_transactions.status.needsReview',
  },
  markedAsReady: {
    icon: 'check',
    color: Color.Green700,
    backgroundColor: Color.Green100,
    translationKey: 'bank_transactions.status.markedAsReady',
  },
  reviewSuggestion: {
    icon: 'sparkleOrbit',
    color: Color.Lavender700,
    translationKey: 'bank_transactions.status.reviewSuggestion',
  },
  private: {
    icon: 'minus',
    color: Color.Grey400,
    backgroundColor: Color.Grey200,
    translationKey: 'bank_transactions.status.private',
  },
}
